import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import type { State } from 'state';
import { fetchConnectFragmentsAction } from 'state/actions/connect-addon';
import { getConnectAddonPanels } from 'state/selectors/connect-addon';
import { withAnalyticsContext, withAnalyticsEvents } from '@atlaskit/analytics-next';
import type { Props } from './connect-fields';
import UnconnectedConnectFields from './connect-fields';
import { asConnectFields } from './connect-fields-provider';

export const selector = createSelector(
    (state: State, props: Props) =>
        getConnectAddonPanels({
            state,
            pageName: 'CREATE_REQUEST',
            location: 'propertyPanels',
            portalId: props.portalId,
            requestTypeId: props.requestTypeId,
        }),
    (connectFragments) => ({
        connectFragments,
    })
);

export const ConnectFields = withAnalyticsContext({
    componentName: 'ConnectFields',
})(
    withAnalyticsEvents({})(
        connect(selector, {
            fetchConnectFragments: fetchConnectFragmentsAction,
        })(asConnectFields(UnconnectedConnectFields))
    )
);

export type { InjectedConnectFieldsSupportProps } from './with-connect-fields-support';
export { withConnectFieldSupport } from './with-connect-fields-support';
